import React, { useMemo } from 'react'
import Select from 'react-select'
import Wrapper from './wrapper'
import { selectStyles } from '~/design'
import { FieldProps } from '~/prix/react/hooks/form'
import { getMeta } from '~/prix/types/zodType'

export default function EnumeratedField({
  meta: {
    isDisabled = false,
    placeholder = 'Selecione...',
    isRequired = false,
    label,
  } = {} as unknown as any,
  id,
  value,
  onDirectChange,
  fieldSchema,
  onBlur,
  isLoading,
  isMultiple = false,
}: FieldProps<any> & {
  children?: React.ReactNode
}) {
  const keysAndLabels = useMemo(() => {
    // Primeiro tenta pegar do getMeta (para schemas Zod com withMeta)
    const metaKeysAndLabels = getMeta(fieldSchema)?.keysAndLabels as
      | Record<string, string>
      | undefined

    // Se não encontrar, tenta pegar diretamente do fieldSchema (compatibilidade com código antigo)
    return metaKeysAndLabels || (fieldSchema as any).keysAndLabels || {}
  }, [fieldSchema])

  const inputOptions = useMemo(
    () =>
      Object.keys(keysAndLabels).map(key => ({
        value: key,
        label: keysAndLabels[key],
      })),
    [keysAndLabels],
  )

  const finalValue = isMultiple
    ? value
      ? value.map((key: string) => ({
          value: key,
          label: keysAndLabels[key as keyof typeof keysAndLabels],
        }))
      : []
    : value
    ? { value, label: keysAndLabels[value as keyof typeof keysAndLabels] }
    : null
  return (
    <Wrapper isRequired={isRequired} label={label} id={id}>
      <Select
        isClearable={!isRequired}
        isMulti={isMultiple}
        value={finalValue}
        onBlur={onBlur}
        styles={selectStyles}
        onChange={result => {
          if (!onDirectChange) return
          if (isMultiple) {
            onDirectChange(result && result.length ? result.map((item: any) => item.value) : null)
          } else {
            onDirectChange(result ? result.value : null)
          }
        }}
        options={inputOptions}
        placeholder={placeholder}
        noOptionsMessage={() => 'Sem opções.'}
        loadingMessage={() => 'Carregando...'}
        inputId={id}
        isDisabled={isDisabled}
      />
    </Wrapper>
  )
}
